import { Box } from 'braid-design-system';
import type { FC } from 'react';

import * as styles from './PurchaseAndUpgradeReferenceCheckImage.css';

export const PurchaseAndUpgradeReferenceCheckImage: FC = () => (
  <Box className={styles.image} />
);
